import { create } from 'zustand';
import { vaultApi } from '../api/vaultApi';
import type { VaultCategory, VaultPack } from '../types/domain';
import { IDLE_LOAD, LOADING_LOAD, READY_LOAD, failedLoad, type LoadState } from './loadState';

interface VaultDataState {
  categories: VaultCategory[];
  packs: VaultPack[];
  load: LoadState;

  loadVaultData: () => Promise<void>;
  reset: () => void;
}

export const useVaultDataStore = create<VaultDataState>((set) => ({
  categories: [],
  packs: [],
  load: IDLE_LOAD,

  async loadVaultData() {
    set({ load: LOADING_LOAD });
    try {
      const [categories, packs] = await Promise.all([vaultApi.getCategories(), vaultApi.getPacks()]);
      set({ categories, packs, load: READY_LOAD });
    } catch (err) {
      set({ load: failedLoad(err) });
    }
  },

  reset() {
    set({ categories: [], packs: [], load: IDLE_LOAD });
  },
}));
